"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowEqual = exports.isBrowser = exports.wrapWithConfigDefaults = exports.inject = exports.assert = exports.createStringParamFunc = exports.canBeDivided = exports.roundByStep = exports.castInto = exports.trueFn = exports.falseFn = exports.emptyFn = void 0;
var tslib_1 = require("tslib");
function emptyFn() { }
exports.emptyFn = emptyFn;
function falseFn() { return false; }
exports.falseFn = falseFn;
function trueFn() { return true; }
exports.trueFn = trueFn;
function castInto(value, targetRange) {
    if (value > targetRange[1]) {
        return targetRange[1];
    }
    if (value < targetRange[0]) {
        return targetRange[0];
    }
    return value;
}
exports.castInto = castInto;
function roundByStep(value, step) {
    if (value < 0) {
        return -roundByStep(-value, step);
    }
    var diff = value % step;
    if (diff < step / 2) {
        return value - diff;
    }
    else {
        return value - diff + step;
    }
}
exports.roundByStep = roundByStep;
function canBeDivided(dividend, divisor) {
    var divideResult = dividend / divisor;
    return (divideResult >> 0) === divideResult;
}
exports.canBeDivided = canBeDivided;
function createStringParamFunc(numberParamFunc) {
    return function () {
        var stringValues = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            stringValues[_i] = arguments[_i];
        }
        var numberValues = stringValues.map(function (str) { return Number(str); });
        return numberParamFunc.apply(void 0, numberValues);
    };
}
exports.createStringParamFunc = createStringParamFunc;
function assert(condition, errorMessage) {
    if (!condition) {
        throw new Error(errorMessage);
    }
}
exports.assert = assert;
function inject(originalFn, additionalFn) {
    var newFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = originalFn.apply(null, args);
        if (result !== false) {
            additionalFn();
        }
        return result;
    };
    newFn.__dui_injected_fn__ = true;
    return newFn;
}
exports.inject = inject;
function wrapWithConfigDefaults(originalFn) {
    var defaultConfig = {};
    function configDefaults(defaults) {
        defaultConfig = defaults;
    }
    var wrappedFn = function (passedConfig) {
        var config = tslib_1.__assign(tslib_1.__assign({}, defaultConfig), passedConfig);
        return originalFn(config);
    };
    wrappedFn.configDefaults = configDefaults;
    return wrappedFn;
}
exports.wrapWithConfigDefaults = wrapWithConfigDefaults;
exports.isBrowser = (typeof window !== 'undefined' && typeof document !== 'undefined');
function shallowEqual(paramA, paramB) {
    if (paramA === paramB) {
        return true;
    }
    if (typeof paramA !== typeof paramB) {
        return false;
    }
    if (typeof paramA !== 'object' ||
        paramA === null ||
        typeof paramB !== 'object' ||
        paramB === null) {
        return false;
    }
    var keysOfA = Object.keys(paramA);
    var keysOfB = Object.keys(paramB);
    if (keysOfA.length !== keysOfB.length) {
        return false;
    }
    return keysOfA.every(function (key) { return paramA[key] === paramB[key]; });
}
exports.shallowEqual = shallowEqual;
